// src/services/bankDetails.ts

const API_BASE_URL = import.meta.env.VITE_API_URL;

export const fetchBankDetails = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/bank-details/get`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      return [];
    }

    const text = await response.text();
    // Try to parse JSON
    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      return [];
    }

    if (data.success && Array.isArray(data.banks)) {
      // Map snake_case API fields to camelCase expected by Checkout component
      return data.banks.map((b) => ({
        ...b,
        bankName: b.bank_name,
        accountName: b.account_name,
        accountNumber: b.account_number,
        swiftCode: b.swift_code,
        isDefault: b.is_default,
        isActive: b.is_active,
      }));
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

export const getDefaultBank = (banks) => {
  if (!banks || banks.length === 0) return null;
  return banks[0];
};

export const formatAccountNumber = (accountNumber) => {
  if (!accountNumber) return '';
  if (accountNumber.length <= 8) return accountNumber;

  const visibleStart = accountNumber.slice(0, 4);
  const visibleEnd = accountNumber.slice(-4);
  const masked = '•'.repeat(Math.min(accountNumber.length - 8, 4));

  return `${visibleStart}${masked}${visibleEnd}`;
};
